import React from 'react'
import Title from '../components/Title'
import Box from '../components/Box'
import Container from '../components/Container'

import { ReactComponent as AlwaysOpen } from '../assets/svg/24Icon.svg'
import { ReactComponent as Emergency } from '../assets/svg/emergencyIcon.svg'
import { ReactComponent as Flag } from '../assets/svg/flag.svg'
import SectionBreak from '../components/SectionBreak'
import { ReactComponent as ServicesImg } from '../assets/svg/services.svg'
import { ReactComponent as Checkmark } from '../assets/svg/checkmark.svg'
import IconButton from '../components/IconButton'

const ServicesData = [
    {
        id: 1,
        icon: 'emergency',
        title: 'Emergency Lockout',
        desc: 'Fast and reliable help to regain access.'
    },
    {
        id: 2,
        icon: 'lock',
        title: 'Lock Installation & Repair',
        desc: 'Secure your property with high-quality locks.'
    },
    {
        id: 3,
        icon: 'keyDuplication',
        title: 'Key Duplication',
        desc: 'Spare or lost keys? We’ve got you covered.'
    },
    {
        id: 4,
        icon: 'keyReplacement',
        title: 'Key Replacement',
        desc: 'Spare or lost keys? We’ve got you covered.'
    },
    {
        id: 5,
        icon: 'smartLock',
        title: 'Smart Lock Solutions',
        desc: 'Modernize your security with keyless entry systems.'
    },
    {
        id: 6,
        icon: 'masterKey',
        title: 'Master Key Systems',
        desc: 'Simplify access for your home or business.'
    },
    {
        id: 7,
        icon: 'security',
        title: 'Security Upgrades',
        desc: 'Advanced locking systems for enhanced protection.'
    },
    {
        id: 8,
        icon: 'safeServices',
        title: 'Safe Services',
        desc: 'Opening, installation, or repair of safes.'
    }
];


function Services() {

    return (
        <div>
            <Container >
                <div className='flex flex-col gap-10'>
                    <Title className='!text-black text-center'>
                        Your Trusted Locksmith Partner
                    </Title>
                    <div className='flex gap-3 flex-col lg:flex-row'>
                        <Box className=' max-w-[400px] mx-auto w-full'>
                            <div className='flex flex-col items-center gap-5'>
                                <AlwaysOpen />
                                <div className='text-center'>
                                    <p className='text-lg font-bold'>Available 7 Days A Week</p>
                                    <span className='text-sm'>From 08:00 - 08:00</span>
                                </div>
                            </div>
                        </Box>
                        <Box className=' max-w-[400px] mx-auto w-full'>
                            <div className='flex flex-col items-center gap-5'>
                                <Emergency />
                                <div className='text-center'>
                                    <p className='text-lg font-bold'>EMERGENCY CALLOUT</p>
                                    <span className='text-sm'>Call 41 31 312 31 31</span>
                                </div>
                            </div>
                        </Box>
                        <Box className=' max-w-[400px] mx-auto w-full'>
                            <div className='flex flex-col items-center gap-5'>
                                <Flag />
                                <div className='text-center'>
                                    <p className='text-lg font-bold'>HIGHLY EXPERIENCED</p>
                                    <span className='text-sm'>15+ years in the industry</span>
                                </div>
                            </div>
                        </Box>
                    </div>
                </div>
                <SectionBreak />
                <div className='flex gap-16 flex-col lg:flex-row'>
                    <div className='flex-1'>
                        <ServicesImg className='w-full h-auto' />
                    </div>
                    <div className='flex-1 flex flex-col gap-4'>
                        <Title className='!text-black'>
                            Welcome To
                            Schliesswerk Bern!
                        </Title>
                        <div className=' text-[#666666]'>
                            At Schliesswerk Bern, we are dedicated to providing top-notch locksmith services with a focus on reliability, professionalism, and customer satisfaction. Whether it’s an emergency lockout, new lock installation, or advanced security solutions, our experienced team is here to help 24/7.
                            With a commitment to quality and trust, we’ve become a go-to locksmith service for homes, businesses, and vehicles.
                        </div>
                        <div className='grid grid-cols-2 gap-x-4 sm:gap-x-6 gap-y-4'>
                            <div className='rounded-full bg-[#EFEFEF] p-2 flex gap-2 items-center font-semibold text-xs sm:text-base'>
                                <Checkmark />
                                <span>Ensuring client security</span>
                            </div>
                            <div className='rounded-full bg-[#EFEFEF] p-2 flex gap-2 items-center font-semibold text-xs sm:text-base'>
                                <Checkmark />
                                <span>Fast response</span>
                            </div>
                            <div className='rounded-full bg-[#EFEFEF] p-2 flex gap-2 items-center font-semibold text-xs sm:text-base'>
                                <Checkmark />
                                <span>Using the latest techniques</span>
                            </div>
                            <div className='rounded-full bg-[#EFEFEF] p-2 flex gap-2 items-center font-semibold text-xs sm:text-base'>
                                <Checkmark />
                                <span>Skilled, certified locksmiths</span>
                            </div>
                        </div>
                        <a href="#contact-us" className='block '>

                            <IconButton className='py-3 mt-4 w-full'>
                                Contact Us
                            </IconButton>
                        </a>
                    </div>

                </div>
                <SectionBreak />

            </Container>
            <div className="bg-[url('assets/images/servicesBg.png')] bg-cover bg-center py-20 relative" id='services'>
                <div className='absolute top-0 left-0 bg-black opacity-70 w-full h-full z-0'>

                </div>
                <Container>
                    <div className='flex flex-col gap-5 z-10 relative'>
                        <Title className='text-center'>
                            Our Services
                        </Title>
                        <div className='text-center text-white text-base md:text-xl'>
                            we combine expertise, trust, and innovation to deliver locksmith services you can rely on. Whether it's a quick fix or a comprehensive security solution, our team is here to ensure your safety and peace of mind.
                        </div>
                        <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 justify-center mt-5'>
                            {ServicesData.map((service) => (
                                <div className='bg-[#FFFFFF1A] rounded-[20px] px-3 py-4 flex items-center gap-3' key={service.id}>
                                    <img src={require('../assets/svg/services/' + service.icon + '.svg')} alt="" />
                                    <div className=''>
                                        <p className='text-white font-medium'>{service.title}</p>
                                        <span className='text-white text-sm'>{service.desc}</span>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </Container>
            </div>
        </div>

    )
}

export default Services